import { makeStyles } from '@material-ui/core/styles';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';

const useStyles = makeStyles(theme => ({
  root: {
    textDecoration: 'none',
    cursor: 'pointer',
    color: props => props.linkColor ?? theme.palette.primary.main,

    '&:hover': {
      color: props => props.hoverColor,
      textDecoration: 'none',
    },
    '&.isDisabled': {
      color: props => props.disableColor,
      pointerEvents: 'none',
    },
    '&:focus-visible': {
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  buttonLink: {
    color: theme.mixins.White(),
    backgroundColor: theme.mixins.AbuDhabiOrange(),
    borderRadius: borderRadius.b28Rem,
    padding: '0.75rem 1.5rem',
    '&:hover': {
      backgroundColor: theme.mixins.AbuDhabiOrange(500),
      overflow: 'hidden',

      '& .MuiIcon-root': {
        animationName: '$arrowMove',
        animationDuration: '.5s',
        animationIterationCount: '1',
      },
    },
    display: 'flex',
    '& .MuiIcon-root': {
      ...theme.mixins.marginLeft(theme.spacing(2)),
    },
  },
  '@keyframes arrowMove': {
    '0%': { transform: 'translateX(0)' },
    '50%': { transform: `translateX(${theme.mixins.translateX(130)}%)` },
    '51%': { transform: `translateX(${theme.mixins.translateX(-130)}%)` },
    '100%': { transform: 'translateX(0)' },
  },
}));

export default useStyles;
